import { axios } from '@/utils/request'

export function loadPermissionList (parameter) {
  return axios({
    url: '/share/permission/list',
    method: 'post',
    data: parameter
  })
}

export function switchEmailAlertEnable (parameter) {
  return axios({
    url: '/share/email/push/status/set',
    method: 'post',
    data: parameter
  })
}

export function changeUserMembership (parameter) {
  return axios({
    url: '/share/user/membership/change',
    method: 'post',
    data: parameter
  })
}

export function exportDataToExcel (parameter) {
  return axios({
    url: '/common/data/export',
    method: 'post',
    responseType: 'blob',
    data: parameter
  })
}

export function bindUser (parameter) {
  return axios({
    url: '/share/user/bind',
    method: 'post',
    data: parameter
  })
}

export function loadKeiyoFiveMonthShareData (parameter) {
  return axios({
    url: '/five/month/share/data',
    method: 'post',
    data: parameter
  })
}

export function loadTestDataList (parameter) {
  return axios({
    url: '/user/test/data/list',
    method: 'post',
    timeout: 60000,
    data: parameter
  })
}

export function checkAlcSensorWebhookConfig (parameter) {
  return axios({
    url: '/alc/sensor/webhook/url/check',
    method: 'post',
    timeout: 6000,
    data: parameter
  })
}

export function saveAlcSensorWebhookConfig (parameter) {
  return axios({
    url: '/alc/sensor/webhook/setting/save',
    method: 'post',
    timeout: 6000,
    data: parameter
  })
}

export function loadAlcSensorWebhookConfig (parameter) {
  return axios({
    url: '/alc/sensor/webhook/setting/load',
    method: 'post',
    timeout: 6000,
    data: parameter
  })
}

export function sendMockAlcSensorWebhookData (parameter) {
  return axios({
    url: '/alc/sensor/webhook/mock',
    method: 'post',
    timeout: 6000,
    data: parameter
  })
}

export function switchEnableAlcSensorWebhookConfig (parameter) {
  return axios({
    url: '/alc/sensor/webhook/enable/switch',
    method: 'post',
    timeout: 6000,
    data: parameter
  })
}

export function getVideoPreviewUrl (parameter) {
  return axios({
    url: '/alc/test/video/url/load',
    method: 'post',
    timeout: 60000,
    data: parameter
  })
}

export function downloadDailyShareDataXlsx (parameter) {
  return axios({
    url: '/daily/share/xlsx/download',
    method: 'post',
    timeout: 60000,
    responseType: 'blob',
    data: parameter
  })
}

export function createMembershipOrder (parameter) {
  return axios({
    url: '/user/pay/order/create',
    method: 'post',
    timeout: 60000,
    data: parameter
  })
}

export function changeUserLanguage (parameter) {
  return axios({
    url: '/user/language/change',
    method: 'post',
    timeout: 60000,
    data: parameter
  })
}

export function loadAdminCurrentAmount (parameter) {
  return axios({
    url: '/alc/sensor/amount/load',
    method: 'post',
    timeout: 60000,
    data: parameter
  })
}

export function loadAlcWebhookRecord (parameter) {
  return axios({
    url: '/alc/sensor/webhook/record',
    method: 'post',
    timeout: 60000,
    data: parameter
  })
}

export function captureMembershipOrder (parameter) {
  return axios({
    url: '/user/pay/order/capture',
    method: 'post',
    timeout: 60000,
    data: parameter
  })
}

export function checkOrderStatus (parameter) {
  return axios({
    url: '/user/order/status/check',
    method: 'post',
    timeout: 60000,
    data: parameter
  })
}

export function resetInfo (parameter) {
  return axios({
    url: '/user/login/pwd/reset',
    method: 'post',
    data: parameter
  })
}

export function resetUserName (parameter) {
  return axios({
    url: '/user/name/reset',
    method: 'post',
    data: parameter
  })
}

export function deleteSharePermission (parameter) {
  return axios({
    url: '/share/permission/del',
    method: 'post',
    data: parameter
  })
}

export function loadKeiyoUserSetting (parameter) {
  return axios({
    url: '/keiyo/user/setting/load',
    method: 'post',
    data: parameter
  })
}

export function loadAdminBindLinkCodeInfo (parameter) {
  return axios({
    url: '/share/auth/link/get',
    method: 'post',
    data: parameter
  })
}

export function loadUserAttendanceRecord (parameter) {
  return axios({
    url: '/user/attendance/stat/load',
    method: 'post',
    data: parameter
  })
}

export function getUserAttendanceRecord (parameter) {
  return axios({
    url: '/user/attendance/info/record',
    method: 'post',
    data: parameter
  })
}

export function loadUserDriveLogList (parameter) {
  return axios({
    url: '/user/drive/log/record',
    method: 'post',
    data: parameter
  })
}

export function createAdminUser (parameter) {
  return axios({
    url: '/admin/user/create',
    method: 'post',
    data: parameter
  })
}

export function saveAdminUserInfo (parameter) {
  return axios({
    url: '/admin/user/info/save',
    method: 'post',
    data: parameter
  })
}

export function resetAdminUserPwd (parameter) {
  return axios({
    url: '/admin/user/pwd/reset',
    method: 'post',
    data: parameter
  })
}

export function loadAccidentList (parameter) {
  return axios({
    url: '/accident/list',
    method: 'post',
    data: parameter
  })
}

export function createAccident (parameter) {
  return axios({
    url: '/accident/create',
    method: 'post',
    data: parameter
  })
}

export function updateAccident (parameter) {
  return axios({
    url: '/accident/update',
    method: 'post',
    data: parameter
  })
}

export function deleteAccident (parameter) {
  return axios({
    url: '/accident/delete',
    method: 'post',
    data: parameter
  })
}

export function exportAccidentList (parameter) {
  return axios({
    url: '/accident/export',
    method: 'post',
    responseType: 'blob',
    data: parameter
  })
}

export function loadTrainingList (parameter) {
  return axios({
    url: '/training/list',
    method: 'post',
    data: parameter
  })
}

export function loadTrainingExpired (parameter) {
  return axios({
    url: '/training/expired',
    method: 'post',
    data: parameter
  })
}

export function createTraining (parameter) {
  return axios({
    url: '/training/create',
    method: 'post',
    data: parameter
  })
}

export function updateTraining (parameter) {
  return axios({
    url: '/training/update',
    method: 'post',
    data: parameter
  })
}

export function deleteTraining (parameter) {
  return axios({
    url: '/training/delete',
    method: 'post',
    data: parameter
  })
}

export function exportTrainingList (parameter) {
  return axios({
    url: '/training/export',
    method: 'post',
    responseType: 'blob',
    data: parameter
  })
}

export function loadWorkLogList (parameter) {
  return axios({
    url: '/worklog/list',
    method: 'post',
    data: parameter
  })
}

export function createWorkLog (parameter) {
  return axios({
    url: '/worklog/create',
    method: 'post',
    data: parameter
  })
}

export function updateWorkLog (parameter) {
  return axios({
    url: '/worklog/update',
    method: 'post',
    data: parameter
  })
}

export function deleteWorkLog (parameter) {
  return axios({
    url: '/worklog/delete',
    method: 'post',
    data: parameter
  })
}

export function exportWorkLogList (parameter) {
  return axios({
    url: '/worklog/export',
    method: 'post',
    responseType: 'blob',
    data: parameter
  })
}

export function loadMyOrganization (parameter) {
  return axios({
    url: '/user/org/load',
    method: 'post',
    data: parameter
  })
}

export function createOrganization (parameter) {
  return axios({
    url: '/user/org/create',
    method: 'post',
    data: parameter
  })
}

export function joinOrganization (parameter) {
  return axios({
    url: '/user/org/join',
    method: 'post',
    data: parameter
  })
}

export function deleteOrganization (parameter) {
  return axios({
    url: '/user/org/delete',
    method: 'post',
    data: parameter
  })
}

export function loadOrganizationByInviteCode (parameter) {
  return axios({
    url: '/user/org/info/load',
    method: 'post',
    data: parameter
  })
}

export function updateOrganizationName (parameter) {
  return axios({
    url: '/user/org/name/update',
    method: 'post',
    data: parameter
  })
}

export function createOrganizationAdmin (parameter) {
  return axios({
    url: '/user/org/admin/create',
    method: 'post',
    data: parameter
  })
}

export function loadOrganizationAdmins (parameter) {
  return axios({
    url: '/user/org/admin/list',
    method: 'post',
    data: parameter
  })
}

export function loadOrganizationDrivers (parameter) {
  return axios({
    url: '/user/org/driver/list',
    method: 'post',
    data: parameter
  })
}

export function deleteOrganizationDrivers (parameter) {
  return axios({
    url: '/user/org/driver/del',
    method: 'post',
    data: parameter
  })
}

export function updateOrganizationDriverName (parameter) {
  return axios({
    url: '/user/org/driver/name/update',
    method: 'post',
    data: parameter
  })
}

export function changeOrganizationDriverOrg (parameter) {
  return axios({
    url: '/user/org/driver/org/change',
    method: 'post',
    data: parameter
  })
}

export function updateOrganizationAdminName (parameter) {
  return axios({
    url: '/user/org/admin/name/update',
    method: 'post',
    data: parameter
  })
}

export function toggleOrganizationAdminStatus (parameter) {
  return axios({
    url: '/user/org/admin/status/toggle',
    method: 'post',
    data: parameter
  })
}

export function resetOrganizationAdminPassword (parameter) {
  return axios({
    url: '/user/org/admin/password/reset',
    method: 'post',
    data: parameter
  })
}

export function createOrganizationDriver (parameter) {
  return axios({
    url: '/user/org/driver/create',
    method: 'post',
    data: parameter
  })
}

export function loadOrganizationOperationLogs (parameter) {
  return axios({
    url: '/user/org/log/list',
    method: 'post',
    data: parameter
  })
}

export function deleteOrganizationAdmin (parameter) {
  return axios({
    url: '/user/org/admin/del',
    method: 'post',
    data: parameter
  })
}

export function changeOrganizationAdminOrg (parameter) {
  return axios({
    url: '/user/org/admin/org/change',
    method: 'post',
    data: parameter
  })
}
